import { render, staticRenderFns } from "./ArticleListView.vue?vue&type=template&id=47343daa&scoped=true&"
import script from "./ArticleListView.vue?vue&type=script&lang=js&"
export * from "./ArticleListView.vue?vue&type=script&lang=js&"
import style0 from "./ArticleListView.vue?vue&type=style&index=0&id=47343daa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47343daa",
  null
  
)

export default component.exports